<template>
  <div class="agent-table-container">
    <ve-table
      max-height="calc(100vh - 35rem)"
      :fixed-header="true"
      :columns="columns"
      :table-data="tableData"
    />
    <div v-if="isLoading" class="agents-loader">
      <spinner />
      <span>{{
        $t('OVERVIEW_REPORTS.AGENT_CONVERSATIONS.LOADING_MESSAGE')
      }}</span>
    </div>
    <empty-state
      v-else-if="!isLoading && !agentAllMetrics.length"
      :title="$t('OVERVIEW_REPORTS.AGENT_CONVERSATIONS.NO_AGENTS')"
    />
    <!-- <div v-if="agentAllMetrics.length > 0" class="table-pagination">
      <ve-pagination
        :total="agents.length"
        :page-index="pageIndex"
        :page-size="25"
        :page-size-option="[25]"
        @on-page-number-change="onPageNumberChange"
      />
    </div> -->
  </div>
</template>

<script>
import { VeTable, VePagination } from 'vue-easytable';
import Spinner from 'shared/components/Spinner.vue';
import EmptyState from 'dashboard/components/widgets/EmptyState.vue';
import rtlMixin from 'shared/mixins/rtlMixin';
import Thumbnail from 'dashboard/components/widgets/Thumbnail.vue';
import { formatTime } from '@chatwoot/utils';

export default {
  name: 'AgentReportTable',
  components: {
    EmptyState,
    Spinner,
    VeTable,
    VePagination,
  },
  mixins: [rtlMixin],
  props: {
    agents: {
      type: Array,
      default: () => [],
    },
    agentAllMetrics: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    pageIndex: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    tableData() {
      const total = this.agentAllMetrics?.find(e => e.agent_id === 'total');
      const other = this.agentAllMetrics?.find(e => e.agent_id === 'other');
      const tableData = []
      this.agentAllMetrics?.filter(e => e.agent_id !== 'total' && e.agent_id !== 'other').forEach(e => {
        const agentInformation = this.getAgentInformation(e.agent_id);
        tableData.push({
          agent: agentInformation.name,
          email: agentInformation.email,
          thumbnail: agentInformation.thumbnail,
          conversations_count: e.conversations_count || 0,
          resolutions_count: e.resolutions_count || 0,
          conversation_dont_have_reply: e.conversation_dont_have_reply || 0,
          outgoing_messages_count: e.outgoing_messages_count || 0,
          avg_first_response_time: formatTime(e.avg_first_response_time) || 0,
          avg_resolution_time: formatTime(e.avg_resolution_time) || 0,
          percent_resolution_conversation: e.percent_resolution_conversation != '-' ? e.percent_resolution_conversation+'%' : '-' || 0,
        })
      })
      // push other
      if (other) {
        tableData.push({
          agent: 'Khác',
          email: '',
          thumbnail: '',
          conversations_count: other.conversations_count || 0,
          resolutions_count: other.resolutions_count || 0,
          conversation_dont_have_reply: other.conversation_dont_have_reply || 0,
          outgoing_messages_count: other.outgoing_messages_count || 0,
          avg_first_response_time: other.avg_first_response_time || 0,
          avg_resolution_time: other.avg_resolution_time || 0,
          percent_resolution_conversation: other.percent_resolution_conversation || 0,
        })
      }
      // push total
      if (total) {
        tableData.push({
          agent: 'Tổng',
          email: '',
          thumbnail: '',
          conversations_count: total.conversations_count || 0,
          resolutions_count: total.resolutions_count || 0,
          conversation_dont_have_reply: total.conversation_dont_have_reply || 0,
          outgoing_messages_count: total.outgoing_messages_count || 0,
          avg_first_response_time: total.avg_first_response_time || 0,
          avg_resolution_time: total.avg_resolution_time || 0,
          percent_resolution_conversation: total.percent_resolution_conversation || 0,
        })
      }
      return tableData
    },
    columns() {
      return [
        {
          field: 'agent',
          key: 'agent',
          title: this.$t(
            'OVERVIEW_REPORTS.AGENT_CONVERSATIONS.TABLE_HEADER.AGENT'
          ),
          fixed: 'left',
          align: this.isRTLView ? 'right' : 'left',
          width: 25,
          renderBodyCell: ({ row }) => (
            <div class="row-user-block">
              <Thumbnail
                src={row.thumbnail}
                size="32px"
                username={row.agent}
                status={row.status}
              />
              <div class="user-block">
                <h6 class="title text-truncate">{row.agent}</h6>
                <span class="sub-title">{row.email}</span>
              </div>
            </div>
          ),
        },
        {
          field: 'conversations_count',
          key: 'conversations_count',
          title: 'Số hội thoại',
          align: this.isRTLView ? 'right' : 'left',
          width: 10,
        },
        {
          field: 'resolutions_count',
          key: 'resolutions_count',
          title: 'Số hội thoại đã giải quyết',
          align: this.isRTLView ? 'right' : 'left',
          width: 10,
        },
        {
          field: 'conversation_dont_have_reply',
          key: 'conversation_dont_have_reply',
          title: 'Số hội thoại chưa có phản hồi',
          align: this.isRTLView ? 'right' : 'left',
          width: 10,
        },
        {
          field: 'outgoing_messages_count',
          key: 'outgoing_messages_count',
          title: 'Số tin nhắn đã gửi',
          align: this.isRTLView ? 'right' : 'left',
          width: 10,
        },
        {
          field: 'avg_first_response_time',
          key: 'avg_first_response_time',
          title: 'Thời gian trung bình phản hồi đầu tiên',
          align: this.isRTLView ? 'right' : 'left',
          width: 10,
        },
        {
          field: 'avg_resolution_time',
          key: 'avg_resolution_time',
          title: 'Thời gian giải quyết trung bình',
          align: this.isRTLView ? 'right' : 'left',
          width: 10,
        },
        {
          field: 'percent_resolution_conversation',
          key: 'percent_resolution_conversation',
          title: 'Tỷ lệ hội thoại đã giải quyết',
          align: this.isRTLView ? 'right' : 'left',
          width: 10,
        },
      ];
    },
  },
  methods: {
    onPageNumberChange(pageIndex) {
      this.$emit('page-change', pageIndex);
    },
    getAgentInformation(id) {
      return this.agents.find(agent => agent.id === Number(id));
    },
  },
};
</script>

<style lang="scss" scoped>
.agent-table-container {
  display: flex;
  flex-direction: column;
  flex: 1;

  .ve-table {
    &::v-deep {
      th.ve-table-header-th {
        font-size: var(--font-size-mini) !important;
        padding: var(--space-small) var(--space-two) !important;
      }

      td.ve-table-body-td {
        padding: var(--space-one) var(--space-two) !important;
      }
    }
  }

  &::v-deep .ve-pagination {
    background-color: transparent;
  }

  &::v-deep .ve-pagination-select {
    display: none;
  }

  .row-user-block {
    align-items: center;
    display: flex;
    text-align: left;

    .user-block {
      align-items: flex-start;
      display: flex;
      flex-direction: column;
      min-width: 0;
      margin: 0 var(--space-small);

      .title {
        font-size: var(--font-size-small);
        margin: var(--zero);
        line-height: 1.2;
      }
      .sub-title {
        font-size: var(--font-size-mini);
      }
    }
  }

  .table-pagination {
    margin-top: var(--space-normal);
    text-align: right;
  }
}

.agents-loader {
  align-items: center;
  display: flex;
  font-size: var(--font-size-default);
  justify-content: center;
  padding: var(--space-large);
}
</style>